import { createRouter, createWebHistory } from 'vue-router';
import LoginForm from "@/views/LoginForm.vue";
import VerifyOTP from "@/views/VerifyOTP.vue";
import DashboardPage from "@/views/DashboardPage.vue";
import PaymentHistory from "@/views/PaymentHistory.vue";
import NotFound from "@/views/NotFound.vue";
import { jwtDecoded } from '@/helpers';
import InvestmentHistory from '@/views/InvestmentHistory.vue';
import LoginWhatsApp from '@/views/LoginWhatsApp.vue'

const routes = [
    { 
        path: '/', 
        component: LoginForm
    },
    { 
        path: '/send-whatsapp-otp', 
        component: LoginWhatsApp 
    },
    { 
        path: '/verify-otp', 
        component: VerifyOTP,
    },
    { 
        path: '/dashboard', 
        component: DashboardPage,
        meta: { requiresAuth: true }
    },
    { 
        path: '/payment-history', 
        component: PaymentHistory,
        meta: { requiresAuth: true }
    },
    {
        path: '/:catchAll(.*)',
        name: 'NotFound',
        component: NotFound
    },
    {
        path: '/investment-history',
        component: InvestmentHistory,
        meta: { requiresAuth: true }
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach((to, from, next) => {
    const isAuthenticated = localStorage.getItem('jwtToken') !== null;

    if ((to.path === '/' || to.path === '/verify-otp') && isAuthenticated) {
        next('/dashboard');
    } else if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
        next('/');
    } else {
        next();
    }

    const payload = jwtDecoded()
    if (payload && payload.exp) {
        const expiration = payload.exp * 1000;
        if (expiration && Date.now() >= expiration) {
            localStorage.removeItem('jwtToken');
            next('/');
        }
    }
});

export default router;